module.exports = __webpack_public_path__ + "img/fe1cb8b.jpg";